import { IComponentOptions } from 'angular';
import { ManageUsersTableCtrl } from './manage-users-table.controller';

export const ManageUsersTableComponent: IComponentOptions = {
  bindings: {
    getSelectedUsers: '&',
    school: '<',
    schoolUsers: '<',
    sharedState: '<',
    updateSchoolUser: '&',
    users: '<',
  },
  controller: ManageUsersTableCtrl,
  template: require('./manage-users-table.html'),
};
